/** 零宽字符等编辑器占位符 */
function stripEditorPlaceholder(text: string): string {
  return text.replace(/\u200b/g, '').trim()
}

/** 判断文档正文是否为空（含 HTML 编辑器空段落） */
export function isDocumentBodyEmpty(
  content: string,
  format: 'markdown' | 'html',
  livePlainText?: string,
): boolean {
  const plain = stripEditorPlaceholder(livePlainText || '')
  if (plain) return false

  const trimmed = (content || '').trim()
  if (!trimmed) return true
  if (format === 'markdown') return false

  const stripped = trimmed
    .replace(/<p><br\s*\/?><\/p>/gi, '')
    .replace(/<p>\s*<\/p>/gi, '')
    .replace(/<br\s*\/?>/gi, '')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .trim()
  return !stripped
}
